export enum EBiddersPage {
  Search  = 'search',
  Details = 'details',
}
